import type { NpcHullTier, PlayerShip, PlayerShipData, PlayerShipVariant } from "../types";
import shipsJson from "./ships.json";

const data = shipsJson as PlayerShipData;

export function loadShips(): PlayerShip[] {
  return data.ships;
}

export function getShip(
  name: string,
  variant: PlayerShipVariant = "Standard"
): PlayerShip | undefined {
  return data.ships.find((s) => s.name === name && s.variant === variant);
}

export function shipsByRole(role: string): PlayerShip[] {
  return data.ships.filter((s) => s.role === role);
}

export function shipsByHullTier(hullTier: NpcHullTier): PlayerShip[] {
  return data.ships.filter((s) => s.hullTier === hullTier);
}
